import React from "react";
import { useFormik } from "formik";
import { useAlert } from "react-alert";
import { injectIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import * as Yup from "yup";
import { FormattedMessage } from "react-intl";
import { Save } from '@material-ui/icons';
import { Button, TextField } from "@material-ui/core";
import { useRouteMatch } from "react-router-dom";

import { useSubheader } from "../../../../_metronic/layout";
import SectionHeader from "../../../components/layout/SectionHeader";
import * as UserService from "../../../services/UserService";
import * as Constants from "../../../Constants";
import * as AlertService from "../../../AlertService";

function ChangePasswordPage({ intl, ...props }) {
    const match = useRouteMatch();
    const doctorId = match.params.id;

    const alert = useAlert();
    const history = useHistory();
    const subheader = useSubheader();

    useEffect(() => {
        subheader.setTitle(intl.formatMessage({ id: "GENERAL.CHANGE_PASSWORD" }));
    });

    // handlers

    async function handleSubmit(values) {
        let send = {
            ...values,
        }
        let result;
        let success = false;
        result = await UserService.updatePassword(send);
        if (result.status === Constants.STATUTS_200) {
            history.push(`/dashboard`);
            success = true;
        }


        if (success) {
            AlertService.success(alert);
        } else {
            AlertService.error(alert, (await result.json()).message);
        }
    }

    // formik

    let passwordSchema = Yup.string();
    passwordSchema = passwordSchema.required(intl.formatMessage({ id: 'ERRORS.REQUIRED_FIELD' }));

    const validationSchema = Yup.object().shape({
        oldPassword: passwordSchema,
        password: passwordSchema,
    });

    const formik = useFormik({
        initialValues: {
            oldPassword: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        },
    });

    return (
        <Card>
            <form onSubmit={formik.handleSubmit}>
                <Card.Body>
                    <SectionHeader messageId="GENERAL.CHANGE_PASSWORD" />
                    <Row>
                        <Col sm={6} md={4}>
                            <TextField
                                label={intl.formatMessage({ id: 'USER.OLD_PASSWORD' }) + " *"}
                                type="password"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                name="oldPassword"
                                onChange={formik.handleChange}
                                {...formik.getFieldProps("oldPassword")}
                            />
                            {formik.touched.oldPassword && formik.errors.oldPassword ?
                                <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">{formik.errors.oldPassword}</div>
                                </div>
                                : null}
                        </Col>
                        <Col sm={6} md={4}>
                            <TextField
                                label={intl.formatMessage({ id: 'USER.NEW_PASSWORD' }) + " *"}
                                type="password"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                name="password"
                                onChange={formik.handleChange}
                                {...formik.getFieldProps("password")}
                            />
                            {formik.touched.password && formik.errors.password ?
                                <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">{formik.errors.password}</div>
                                </div>
                                : null}
                        </Col>

                    </Row>
                </Card.Body>
                <Card.Footer>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={!formik.isValid || !formik.dirty}
                        endIcon={<Save />}
                    >
                        <FormattedMessage id="ACTIONS.SAVE" />
                    </Button>

                    <span className="text-muted float-right mt-4">* <FormattedMessage id="GENERAL.REQUIRED_FIELDS" /></span>
                </Card.Footer>
            </form>
        </Card>
    )
}

export default injectIntl(ChangePasswordPage);
